export default __webpack_public_path__ + "static/media/Pay2moible Recharge-2.d40d863b.gif";